import { Breadcrumbs, Btn, Ribbon } from "AbstractElements";
import { AddTask, Close } from "Constant";
import { useResourceNavigate } from "hook/useResourceNavigate";
import { Fragment, useMemo } from "react";
import DataTable from "react-data-table-component";
import { Plus } from "react-feather";
import { Card, CardBody, CardFooter, CardHeader, Container } from "reactstrap";
import { IListResource } from "./interface";
import { useCurrentResource } from "hook/useCurrentResource";
import { useMenu } from "Layout/Sidebar/useMenu";
import { ResourceType } from "routers/constant";
const TheListResource = <TData,>(props: IListResource<TData>) => {
  const {
    Filters,
    dataSource,
    tableColumns,
    title,
    parent,
    showBreadcrum = true,
    showCreate = true,
    onRowClicked,
    handlePageSizeChange,
    handlePageChange,
    pagination = true,
    Filter,
    BodyTop,
    totalRows,
    bodyClassName,
    Footer,
  } = props;
  const { toCreate } = useResourceNavigate();
  const resourceName = useCurrentResource();
  const { can } = useMenu();

  const resourceCan = can[resourceName] || {};
  const paginationServer = useMemo(
    () => !!handlePageSizeChange && !!handlePageChange,
    [handlePageSizeChange, handlePageChange]
  );

  return (
    <Fragment>
      {showBreadcrum && (
        <Breadcrumbs mainTitle={title} parent={parent} title={title} />
      )}
      <Container fluid={true}>
        <Card>
          <CardHeader className="d-flex align-items-center justify-content-between">
            <Ribbon
              attrRibbons={{
                className: "ribbon ribbon-bookmark ribbon-primary",
              }}
            >
              {title}
            </Ribbon>
            <div></div>
            <div className="d-flex align-items-center gap-3">
              <div className="todo">
                <div className="todo-list-wrapper"></div>
              </div>
              {showCreate && resourceCan[ResourceType.CREATE] && (
                <Btn
                  attrBtn={{
                    color: "primary d-flex align-items-center",
                    onClick: toCreate,
                  }}
                >
                  <Plus
                    style={{ width: "18px", height: "18px" }}
                    className="me-2"
                  />
                  Thêm mới
                </Btn>
              )}
            </div>
          </CardHeader>
          <CardBody className={bodyClassName}>
            {BodyTop}
            <div>
              {Filter}
              <div className="todo">
                <div className="todo-list-wrapper">
                  <div className="todo-list-container todo-list-footer">
                    <div className={"new-task-wrapper mb-4"}>
                      <Btn
                        attrBtn={{
                          color: "danger",
                          className: "cancel-btn",
                          id: "close-task-panel",
                        }}
                      >
                        {Close}
                      </Btn>
                      <Btn
                        attrBtn={{
                          color: "success",
                          className: "ms-3 add-new-task-btn",
                          id: "add-task",
                        }}
                      >
                        {AddTask}
                      </Btn>
                    </div>
                    {Filters && Filters}
                    <div className="table-responsive product-table">
                      <DataTable
                        noHeader
                        pagination={pagination}
                        paginationServer={paginationServer}
                        columns={tableColumns}
                        data={dataSource}
                        highlightOnHover={true}
                        striped={true}
                        responsive={true}
                        onRowClicked={onRowClicked}
                        paginationTotalRows={totalRows}
                        onChangeRowsPerPage={handlePageSizeChange}
                        onChangePage={handlePageChange}
                        paginationComponentOptions={{
                          rowsPerPageText: "Dòng mỗi trang",
                        }}
                        noDataComponent="Không có dữ liệu"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
          <CardFooter>{Footer && Footer}</CardFooter>
        </Card>
      </Container>
    </Fragment>
  );
};

export default TheListResource;
